import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { Link as RouterLink, withRouter } from "react-router-dom";
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardHeader,
  CardContent,
  Divider,
  InputAdornment,
  SvgIcon,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  TablePagination,
  Button
} from '@material-ui/core';


import { NEONPV_CONFIG } from 'config.js';

import { connect} from 'react-redux';
import { bindActionCreators } from 'redux';


const useStyles = makeStyles(theme => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    // minWidth: 1050
  },
  nameContainer: {
    // display: 'flex',
    // alignItems: 'center',
    // marginLeft: theme.spacing(1)
  },
  queryField: {
    // width: 300
    flexBasis: 260,
    marginRight:20,
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  actions: {
    justifyContent: 'flex-end'
  },
  bulkAction: {
    marginLeft: theme.spacing(2)
  },
}));


const InquiryTable = props => {
  const { className, users, queryParams, ...rest } = props;

  const classes = useStyles();

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const [listData, setListData] = useState([]);

  const searchData = () => {

    var url = `${NEONPV_CONFIG.HOSTNAME}/notice/queryNoticeList`;

    fetch(url)
    .then(res => res.json())
    .then(snapshot => {
      var list  = [];
      if( snapshot.resultData != null){
        snapshot.resultData.forEach( doc => {
          list.push(doc);
        });
      }
      setListData( list );
    }
    );
  }


  useEffect( () => {

    // searchData();

  //  {
  //     "id": 12,
  //     "title": "공지사항1-2",
  //     "author": "공지사항1-2",
  //     "regdate": "2021-03-02",
  //     "contents": "공지사항1-2\n공지사항1-2\n공지사항1-2\n공지사항1-2\n공지사항1-2\n",
  //     "flag": "1",
  //     "updateTime": "2021-03-02T06:42:05.000Z"
  // },
  // {
  //     "id": 11,
  //     "title": "공지사항1-1",
  //     "author": "admin",
  //     "regdate": "2021-03-02",
  //     "contents": "공지사항1-1공지사항1-1공지사항1-1\n공지사항1-1\n공지사항1-1\n공지사항1-1\n공지사항1-1",
  //     "flag": "1",
  //     "updateTime": "2021-03-02T06:41:44.000Z"
  // },
  var list  = [];

    list.push(   
      {
      "id": "12",
      "user_name": "김갑순",
      "user_status": "입욕 요청",
      "ocur_time": "21.04.21 19:00",
      "action": "",
      },

      {
        "id": "11",
        "user_name": "이을용",
        "user_status": "식사준비",
        "ocur_time": "21.04.21 19:00",
        "action": "완료",
      },

      {
        "id": "10",
        "user_name": "박병희",
        "user_status": "외출도움",
        "ocur_time": "21.04.21 13:00",
        "action": "보류",
      },

      {
        "id": "9",
        "user_name": "박을순",
        "user_status": "소주 주문",
        "ocur_time": "21.04.21 13:00",
        "action": "거절",
      }, 
      
      
    );

  setListData(list);
        
    return () => {};
  }, []);


  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(event.target.value);
  };


  const startRow = (page*rowsPerPage);


  return (

    <Card className={clsx(classes.root, className)} {...rest} >

      <CardHeader
        title="문의 및 호출"
        titleTypographyProps={{ align: "center", variant:'h4' }}
      />

      <Divider />

      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell width="5%" align="center" className={classes.nameContainer}>No</TableCell>                
                  <TableCell width="20%" align="center">이용자 및 보호자</TableCell>
                  <TableCell width="20%" align="center">내용</TableCell>
                  <TableCell width="30%" align="center">문의일시</TableCell>
                  <TableCell width="25%" align="center">상태</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {listData.slice(0+startRow, rowsPerPage+(page*rowsPerPage)).map(module => (

                  <TableRow
                    className={classes.tableRow}
                    key={module.id}
                    component={RouterLink} to={`/firstaid/update/${module.id}`}
                    >

                    <TableCell width="5%" align="center">
                      <div className={classes.nameContainer}>
                        <Typography variant="body1">{module.id}</Typography>
                      </div>
                    </TableCell>
                    <TableCell width="20%" align="left">{module.user_name}</TableCell>
                    <TableCell width="20%" align="left">{module.user_status}</TableCell>
                    <TableCell width="30%" align="center">{module.ocur_time}</TableCell>
                    <TableCell width="25%" align="center">
                      {module.action ||
                      <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        component={RouterLink} to={`/firstaid/update/${module.id}`}
                      >조치</Button>
                    }
                    </TableCell>
                  </TableRow>
                ))}

              </TableBody>
            </Table>
          </div>
        </PerfectScrollbar>
      </CardContent>

      <CardActions className={classes.actions}>
        <TablePagination
          component="div"
          count={listData.length}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          page={page}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25]}
        />
      </CardActions>
    </Card>
  );
};

InquiryTable.propTypes = {
  className: PropTypes.string,
};

export default withRouter(InquiryTable);

